<template>
  <v-card outlined :height="height">
    <v-card-title>{{ $t('sod.anal.rslt.detail') }}</v-card-title>
    <v-card-text :style="{ height: `${height - 30}px` }">
      <v-row class="pt-1">
        <v-col cols="12">
          <v-card elevation="0" class="mt-2">
            <v-tabs v-model="selectedTab" height="60" slider-size="2" centered icons-and-text :background-color="color(3)" class="rounded-0">
              <!--
                Vuetify 2.x에서는 <v-tab>이 value 속성을 지원하지 않는다.
                href 속성을 사용하고 값에는 '#'을 앞에 넣어주어야 한다.
                <v-tabs>의 v-model에 할당되는 값에는 '#'이 빠진 값이 할당된다.
              -->
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-tab href="#S"><v-icon>mdi-account-check</v-icon>{{ $t('sod.ttl.sod.vltn') }}</v-tab>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-tab href="#R"><v-icon>mdi-shield-check-outline</v-icon>{{ $t('sod.ttl.ra.vltn') }}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="selectedTab">
              <v-tab-item value="S" transition="false" reverse-transition="false">
                <v-row>
                  <v-col cols="12">
                    <v-tabs v-model="selectedSodTab" height="35" slider-size="2" :background-color="color(3)" class="rounded-0">
                      <v-tab href="#SR">
                        <v-img src="@/assets/image/diagram/node_single_role_icon.png" class="item-image" />
                        <span class="pl-2">{{ $t('rtrck.title.srol') }}</span>
                      </v-tab>
                      <v-tab href="#CR">
                        <v-img src="@/assets/image/diagram/node_composite_role_icon.png" class="item-image" />
                        <span class="pl-2">{{ $t('rtrck.title.crol') }}</span>
                      </v-tab>
                      <v-tab href="#US">
                        <v-img src="@/assets/image/diagram/node_user_icon.png" class="item-image" />
                        <span class="pl-2">{{ $t('rtrck.title.user') }}</span>
                      </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="selectedSodTab">
                      <!--
                        <v-tab-item> 내에 포함된 Vue 컴포넌트가 lazy loading되는 것
                        (lazy loading이 되면 최초 tab 클릭 시 Vue 컴포넌트가 초기화 되지 않은 상태여서 오동작 발생)
                        을 방지하기 위하여 eager 속성을 설정함.
                      -->
                      <v-tab-item value="SR" transition="false" reverse-transition="false" eager>
                        <sod-srol-list usage="SR" :time="analYmdhms" :type="selectedSodTab" :height="childHeight" />
                      </v-tab-item>
                      <v-tab-item value="CR" transition="false" reverse-transition="false" eager>
                        <sod-crol-list usage="CR" :time="analYmdhms" :type="selectedSodTab" :height="childHeight" />
                      </v-tab-item>
                      <v-tab-item value="US" transition="false" reverse-transition="false" eager>
                        <sod-user-list usage="US" :time="analYmdhms" :type="selectedSodTab" :height="childHeight" />
                      </v-tab-item>
                    </v-tabs-items>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item value="R" transition="false" reverse-transition="false">
                <v-row>
                  <v-col cols="12">
                    <v-tabs v-model="selectedRaTab" height="35" slider-size="2" :background-color="color(3)" class="rounded-0">
                      <v-tab href="#SR">
                        <v-img src="@/assets/image/diagram/node_single_role_icon.png" class="item-image" />
                        <span class="pl-2">{{ $t('rtrck.title.srol') }}</span>
                      </v-tab>
                      <v-tab href="#CR">
                        <v-img src="@/assets/image/diagram/node_composite_role_icon.png" class="item-image" />
                        <span class="pl-2">{{ $t('rtrck.title.crol') }}</span>
                      </v-tab>
                      <v-tab href="#US">
                        <v-img src="@/assets/image/diagram/node_user_icon.png" class="item-image" />
                        <span class="pl-2">{{ $t('rtrck.title.user') }}</span>
                      </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="selectedRaTab">
                      <v-tab-item value="SR" transition="false" reverse-transition="false" eager>
                        <ra-srol-list usage="SR" :time="analYmdhms" :type="selectedRaTab" :height="childHeight" />
                      </v-tab-item>
                      <v-tab-item value="CR" transition="false" reverse-transition="false" eager>
                        <ra-crol-list usage="CR" :time="analYmdhms" :type="selectedRaTab" :height="childHeight" />
                      </v-tab-item>
                      <v-tab-item value="US" transition="false" reverse-transition="false" eager>
                        <ra-user-list usage="US" :time="analYmdhms" :type="selectedRaTab" :height="childHeight" />
                      </v-tab-item>
                    </v-tabs-items>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import SodSrolList from './AnalyzedSodList.vue';
import SodCrolList from './AnalyzedSodList.vue';
import SodUserList from './AnalyzedSodList.vue';
import RaSrolList from './AnalyzedRaList.vue';
import RaCrolList from './AnalyzedRaList.vue';
import RaUserList from './AnalyzedRaList.vue';

export default {
  components: {
    SodCrolList,
    SodSrolList,
    SodUserList,
    RaCrolList,
    RaSrolList,
    RaUserList,
  },
  props: {
    analYmdhms: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
  data() {
    return {
      selectedTab: '',
      selectedSodTab: '',
      selectedRaTab: '',
    };
  },
  computed: {
    childHeight() {
      return this.height - 125;
    },
  },
  methods: {
    color(saturation) {
      return this.$vuetify.theme.isDark ? `grey darken-${saturation}` : `grey lighten-${saturation - 2}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.item-image {
  height: 16px;
  width: 16px;
  vertical-align: middle;
  flex: none;
}
</style>
